import React, { Component } from 'react';
import { connect } from 'react-redux';
import { defaultMemoize } from 'reselect';
import uniqBy from 'lodash/uniqBy';

import ChannelsView from './Channels.view';

import { getChannels } from './Channels.selectors';

export class ChannelsContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.exportCSV = this.exportCSV.bind(this);

    this.getAccounts = defaultMemoize(this.getAccounts);
  }

  getAccounts(amazonAccounts = []) {
    const result = amazonAccounts.map(account => ({
      label: account.value,
      value: account.value,
    }));
    return uniqBy(result, account => account.value);
  }

  componentDidMount() {
    this.getChannels(this.props);
    this.intervalId = setInterval(()=>{
      this.getChannels(this.props);
    }, 30000);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getChannels(nextProps);
    }
  }

  getChannels(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_CHANNELS',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  exportCSV(exportType = 'amazon-reseller'){
    const { dispatch, filtersFormState } = this.props;
    dispatch({
      type: 'EXPORT_CHANNELS_CSV',
      payload: {
        exportType,
        filters: filtersFormState.data,
      }
    });
  }

  componentWillUnmount(){
    clearInterval(this.intervalId);
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'CHANNELS_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'CHANNELS_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'CHANNEL_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    const { amazonAccounts } = this.props;
    return (<ChannelsView
      {...this.props}
      amazonAccounts={this.getAccounts(amazonAccounts)}
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      exportCSV={this.exportCSV}
    />);
  }

}

function mapStateToProps(state) {
  const { channels, dynamicData } = state;
  return {
    channels: getChannels(state),
    filtersFormState: channels.filtersFormState,
    page: channels.page,
    amazonAccounts: dynamicData.amazonAccounts,
  };
}

export default connect(mapStateToProps)(ChannelsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/Channels.container.js